import { Heading,Img} from "../../components";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import ModelFeatures from "./ModelFeatures";

export default function RiskModel() {
  return (
    <>
      
      <div className="w-full bg-gray-300">
        <div className="relative bg-gray-300">
          <div className="absolute left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[108px] md:gap-[81px] sm:gap-[54px]">
            <div className="container-xs md:px-5">
              <Navbar />
            </div>
          </div>  

          <div className="flex justify-center bg-gray-300 py-24 md:py-5">
            <div className="container-xs flex items-center justify-center md:flex-col md:px-5">
              <Heading size="headings" as="h2" className="text-[21px] font-semibold text-blue_gray-900">
                Risk Model
              </Heading>

              <div className="flex justify-center my-5">
                <Img
                  src="/images/elipse-blue.svg"
                  className="w-[200px] h-auto"
                />
              </div>

              
              <div className="flex flex-1 flex-col mt-6 gap-9 md:self-stretch">
              {/* <Heading  size="headingmd"  as="h3" className="relative top-6 text-[36px] font-semibold leading-[140%] text-blue_gray-900 md:text-[34px] sm:text-[32px]" > */}
              
              <div className="text-[24px] font-semibold text-blue_gray-900 md:text-[24px] sm:text-[20px] leading-relaxed text-justify">
                
                TRG’s risk engine follows a bottom-up approach to the simulation of portfolio probability distributions, 
                which allows computation of risk metrics at the portfolio, sub-portfolio, and position levels.
                The engine’s built-in flexibility allows the user to select&nbsp;
                <span className="text-pink-a200">
                    model specifications tailored to their investment strategy, as well as detailed assessment of portfolio risk concentrations. 
                </span>
              </div>  
                
                
                <div className="flex flex-1 items-center md:flex-col md:self-stretch">
                  <div className="flex flex-1 justify-center md:flex-row md:self-stretch sm:flex-col ">
                    
                    <ModelFeatures className="w-1/1"/>
                    
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>

      {/* Footer */}
      <div>
        <Footer />
      </div>

    </>
  );
}
